import KalviumSdk from '@kalvi-education/kalvium-sdk'

const checkWidgetAccess = async (widgetId, email) => {
    let allowList = []
    const metadataEntries = await KalviumSdk.services.metadata.get({
        key: 'allowList',
        entityId: widgetId,
        entityType: 'widget',
    })

    if (metadataEntries && metadataEntries.length > 0) {
        allowList = metadataEntries[0]?.value ?? []
    }

    return allowList.includes(email)
}

const getWidgetInfo = async widgetId => {
    return await KalviumSdk.services.metadata.get({
        entityId: widgetId,
        entityType: 'widget',
    })
}

export { checkWidgetAccess, getWidgetInfo }
